// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "-legacy." + {"56":"a66c75a8","127":"f30601dd","190":"1b41a4d3","935":"3d7aafa7"}[chunkId] + ".js";
};